"use client";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { Truck } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function TrackOrder() {
  const [trackNumber, setTrackNumber] = useState(null);
  const router = useRouter();
  const { success } = useToast();

  const handleTrackNumber = (e) => {
    e.preventDefault();

    if (trackNumber) {
      success(`Query of ${trackNumber} order has been sent`);
      setTrackNumber("");
      router.push(`/orders/${trackNumber}`);
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="flex gap-1.5 items-center cursor-pointer group">
          <Truck
            size={18}
            className="text-brand-sky group-hover:text-white transition-colors"
          />
          <span className="text-white group-hover:text-brand-sky text-sm font-medium transition-colors">
            Track My Order
          </span>
        </div>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] rounded-2xl border-brand-light shadow-brand-lg">
        <DialogHeader>
          <DialogTitle className="text-brand-navy flex items-center gap-2">
            <Truck size={18} className="text-brand-sky" />
            Track Order
          </DialogTitle>
          <DialogDescription className="text-muted-foreground">
            Put your order number, We&apos;re processing it with care and will
            update you shortly.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="items-center gap-4">
            <form onSubmit={handleTrackNumber} className="space-y-3">
              <Label
                htmlFor="Order Number"
                className="text-right text-brand-navy font-medium"
              >
                Order Number
              </Label>
              <Input
                name="trackNumber"
                value={trackNumber}
                onChange={(e) => setTrackNumber(e.target.value)}
                className="border-brand-light focus:border-brand-sky focus:ring-2 focus:ring-brand-sky/20 rounded-xl transition-all"
              />
              <DialogClose asChild>
                <Button
                  disabled={!trackNumber}
                  type="submit"
                  className="flex justify-end w-fit gradient-primary hover:opacity-95 text-white font-semibold rounded-xl shadow-brand hover:shadow-brand-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed px-6"
                >
                  Submit
                </Button>
              </DialogClose>
            </form>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}